import { RESET_REASSIGN_ADVISOR_FORM } from '../actionTypes';
import { creditsActions } from '../reducer';

export default () => creditsActions[RESET_REASSIGN_ADVISOR_FORM]();
